import { buildModelManager } from "../builder.js";
const DefaultCampaignSelection = {
  __typename: true,
  id: true,
  campaignTemplateId: true,
  createdAt: true,
  createdById: true,
  errorMessage: true,
  imageAssets: { url: true, mimeType: true, fileName: true },
  name: true,
  priority: true,
  processingStep: true,
  settings: true,
  shopId: true,
  smartTriggerAudience: true,
  smartTriggerCustomUrlPattern: true,
  smartTriggerPageScope: true,
  smartTriggerSensitivity: true,
  status: true,
  template: true,
  templateConfig: true,
  templateVersion: true,
  triggerMode: true,
  type: true,
  updatedAt: true,
  updatedById: true
};
const modelApiIdentifier = "campaign";
const pluralModelApiIdentifier = "campaigns";
;
;
;
;
;
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultCampaignSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultCampaignSelection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultCampaignSelection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultCampaignSelection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultCampaignSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultCampaignSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultCampaignSelection,
    namespace: null
  },
  {
    type: "action",
    operationName: "createCampaign",
    operationReturnType: "CreateCampaign",
    functionName: "create",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: { campaign: { required: false, type: "CreateCampaignInput" } },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultCampaignSelection
  },
  {
    type: "action",
    operationName: "bulkCreateCampaigns",
    functionName: "bulkCreate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "create",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: { inputs: { required: true, type: "[BulkCreateCampaignsInput!]" } },
    paramOnlyVariables: [],
    defaultSelection: DefaultCampaignSelection
  },
  {
    type: "action",
    operationName: "updateCampaign",
    operationReturnType: "UpdateCampaign",
    functionName: "update",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      id: { required: true, type: "GadgetID" },
      campaign: { required: false, type: "UpdateCampaignInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultCampaignSelection
  },
  {
    type: "action",
    operationName: "bulkUpdateCampaigns",
    functionName: "bulkUpdate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "update",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: { inputs: { required: true, type: "[BulkUpdateCampaignsInput!]" } },
    paramOnlyVariables: [],
    defaultSelection: DefaultCampaignSelection
  },
  {
    type: "action",
    operationName: "deleteCampaign",
    operationReturnType: "DeleteCampaign",
    functionName: "delete",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: true,
    variables: { id: { required: true, type: "GadgetID" } },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: false,
    hasCreateOrUpdateEffect: false,
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "bulkDeleteCampaigns",
    functionName: "bulkDelete",
    isBulk: true,
    isDeleter: true,
    hasReturnType: false,
    acceptsModelInput: false,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "delete",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: { ids: { required: true, type: "[GadgetID!]" } },
    paramOnlyVariables: [],
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "runAiGenerationCampaign",
    operationReturnType: "RunAiGenerationCampaign",
    functionName: "runAiGeneration",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: { id: { required: true, type: "GadgetID" } },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: true,
    acceptsModelInput: false,
    hasCreateOrUpdateEffect: false,
    defaultSelection: DefaultCampaignSelection
  },
  {
    type: "action",
    operationName: "bulkRunAiGenerationCampaigns",
    functionName: "bulkRunAiGeneration",
    isBulk: true,
    isDeleter: false,
    hasReturnType: true,
    acceptsModelInput: false,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "runAiGeneration",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: { ids: { required: true, type: "[GadgetID!]" } },
    paramOnlyVariables: [],
    defaultSelection: DefaultCampaignSelection
  },
  {
    type: "action",
    operationName: "upsertCampaign",
    operationReturnType: "UpsertCampaign",
    functionName: "upsert",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      on: { required: false, type: "[String!]" },
      campaign: { required: false, type: "UpsertCampaignInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: ["on"],
    hasReturnType: {
      "... on CreateCampaignResult": { hasReturnType: false },
      "... on UpdateCampaignResult": { hasReturnType: false }
    },
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultCampaignSelection
  },
  {
    type: "action",
    operationName: "bulkUpsertCampaigns",
    functionName: "bulkUpsert",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "upsert",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: { inputs: { required: true, type: "[BulkUpsertCampaignsInput!]" } },
    paramOnlyVariables: ["on"],
    defaultSelection: DefaultCampaignSelection
  }
];
const CampaignManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultCampaignSelection,
  operations
);
export {
  CampaignManager,
  DefaultCampaignSelection
};
//# sourceMappingURL=Campaign.js.map
